export default "__VITE_ASSET__DGIElCx4__"